import React, { FunctionComponent as FC } from 'react';
import './index.scss';
import icssiMark from '../../assets/9-logos/icssi-mask.svg';
import netsciMark from '../../assets/9-logos/netsci-mark.png';
import ic2s2Mark from '../../assets/9-logos/ic2s2-mark.png';

interface Talk {
  date: string;
  title: string;
  venue: string;
  url: string;
  logo: React.ReactNode;
}

/* A raster or SVG logo drawn through a CSS mask, so it takes the row's grey */
const MaskLogo: FC<{ src: string; label: string; width: number; height: number }> = ({ src, label, width, height }) => (
  <span className='lm' role='img' aria-label={label} style={{ width, height, WebkitMaskImage: `url(${src})`, maskImage: `url(${src})` }} />
);

/* Data | Art Symposium: a typographic mark */
const DataArtMark: FC = () => (
  <svg viewBox='0 0 110 40'>
    <text x='0' y='18' fontSize='15' fontWeight='800' fontFamily='Inter,sans-serif' fill='currentColor'>DATA|ART</text>
    <text x='0' y='35' fontSize='12' fontWeight='700' fontFamily='Inter,sans-serif' fill='currentColor'>SYMPOSIUM</text>
  </svg>
);

// Newest first
const talks: Talk[] = [
  { date: 'Jul 2026', title: 'LLM-Native Figures', venue: 'IC2S2 2026, Burlington', url: 'https://ic2s2-2026.org/', logo: <MaskLogo src={ic2s2Mark} label='IC2S2' width={80} height={34} /> },
  { date: 'Jun 2026', title: 'LLM-Native Figures', venue: 'ICSSI 2026, Boulder', url: 'https://icssi.org/', logo: <MaskLogo src={icssiMark} label='ICSSI' width={96} height={17} /> },
  { date: 'Jun 2026', title: 'LLM-Native Figures', venue: 'NetSci 2026, Boston', url: 'https://www.netsci2026.com/', logo: <MaskLogo src={netsciMark} label='NetSci 2026' width={92} height={38} /> },
  { date: 'Jun 2025', title: 'A Hybrid Human-AI Interface for Discovery', venue: 'Data | Art Symposium, Harvard', url: 'https://data-art.info/', logo: <DataArtMark /> },
];

interface InvitedPresentationsPageProps {
}

const InvitedPresentationsPage: FC<InvitedPresentationsPageProps> = () => {
  return (
    <section className='talks contain' id='talks'>
      <h2>Invited Presentations</h2>
      <div className='tlist'>
        {talks.map((t) => (
          <a className='trow' key={t.title + t.venue} href={t.url} target='_blank' rel='noopener noreferrer'>
            <span className='tm'>{t.logo}</span>
            <span className='td'>{t.date}</span>
            <span className='tt'>{t.title}</span>
            <span className='tv'>{t.venue}</span>
          </a>
        ))}
      </div>
    </section>
  )
}

export default InvitedPresentationsPage;
